var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "job-preview-content-outline",
    _vm._g(
      { attrs: { title: _vm.title, "data-test": "interview" } },
      _vm.$listeners
    ),
    [
      _c(
        "job-preview-content",
        _vm._g(
          {
            attrs: {
              "comment-highlights": _vm.commentHighlights,
              "text-count-mode": _vm.textCountMode,
              "highlight-mode": _vm.highlightMode,
              "text-counts": _vm.textCounts,
            },
            scopedSlots: _vm._u([
              {
                key: "body",
                fn: function () {
                  return [
                    _c("p", [
                      _vm.zip
                        ? _c("span", {
                            attrs: {
                              id:
                                _vm.targetIdMap.selection.interview.zip +
                                "-" +
                                _vm.index,
                              "data-test": "zip",
                            },
                            domProps: {
                              innerHTML: _vm._s("〒 " + _vm.zip + "<br>"),
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.address
                        ? _c("span", {
                            staticClass: "pega-pre-wrap",
                            attrs: {
                              id:
                                _vm.targetIdMap.selection.interview.address +
                                "-" +
                                _vm.index,
                              "data-test": "address",
                            },
                            domProps: {
                              innerHTML: _vm._s(_vm.address + "<br>"),
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.person
                        ? _c("span", {
                            attrs: {
                              id:
                                _vm.targetIdMap.selection.interview.person +
                                "-" +
                                _vm.index,
                              "data-test": "person",
                            },
                            domProps: {
                              innerHTML: _vm._s(
                                "担当者 ／ " + _vm.person + "<br>"
                              ),
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.tel
                        ? _c("span", {
                            attrs: {
                              id:
                                _vm.targetIdMap.selection.interview.tel +
                                "-" +
                                _vm.index,
                              "data-test": "tel",
                            },
                            domProps: {
                              textContent: _vm._s("Tel ／ " + _vm.tel),
                            },
                          })
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.map
                      ? _c(
                          "p",
                          {
                            staticClass: "btn-style-02 pt10 pb10 map-button",
                            attrs: { "data-test": "map" },
                          },
                          [
                            _c(
                              "a",
                              {
                                style:
                                  "background: url(" +
                                  _vm.userCommonImageUrlForPc +
                                  "/icn_arrow_05.png) no-repeat 8px center;",
                                attrs: {
                                  href: "" + _vm.googleMapURL + _vm.map,
                                  target: "_blank",
                                  "data-test": "map-button",
                                },
                              },
                              [_c("span", [_vm._v("地図を見る")])]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          _vm.$listeners
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }